// extracted by mini-css-extract-plugin
module.exports = {"copyWrapper":"CopyButton_copyWrapper__3_Up7","copiedMessage":"CopyButton_copiedMessage__1PKEF"};